import { EBuildingType } from '../types/buildingType';
import { EOfficeType } from '../../api-models/common/json_query';

const mapOfficeTypeWithBuildingType: Partial<Record<EOfficeType, EBuildingType[]>> = {
  [EOfficeType.Office]: [
    EBuildingType.BusinessCenter,
    EBuildingType.OfficeBuilding,
    EBuildingType.AdministrativeBuilding,
    EBuildingType.MultifunctionalComplex,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
    EBuildingType.House,
  ],
  [EOfficeType.TradeArea]: [
    EBuildingType.MultifunctionalComplex,
    EBuildingType.ShoppingCenter,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
  ],
  [EOfficeType.FreeAppointmentObject]: [
    EBuildingType.ShoppingCenter,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
    EBuildingType.House,
    EBuildingType.Other,
  ],
  [EOfficeType.PublicCatering]: [
    EBuildingType.ShoppingCenter,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
    EBuildingType.House,
    EBuildingType.Other,
  ],
  [EOfficeType.AutoService]: [
    EBuildingType.ShoppingCenter,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
    EBuildingType.House,
    EBuildingType.Other,
  ],
  [EOfficeType.DomesticServices]: [
    EBuildingType.ShoppingCenter,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
    EBuildingType.House,
    EBuildingType.Other,
  ],
  [EOfficeType.Warehouse]: [
    EBuildingType.AdministrativeBuilding,
    EBuildingType.MultifunctionalComplex,
    EBuildingType.Warehouse,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
    EBuildingType.Other,
  ],
  [EOfficeType.Manufacture]: [
    EBuildingType.AdministrativeBuilding,
    EBuildingType.MultifunctionalComplex,
    EBuildingType.Warehouse,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
    EBuildingType.Other,
  ],
  [EOfficeType.Building]: [
    EBuildingType.BusinessCenter,
    EBuildingType.OfficeBuilding,
    EBuildingType.AdministrativeBuilding,
    EBuildingType.MultifunctionalComplex,
    EBuildingType.ShoppingCenter,
    EBuildingType.Warehouse,
    EBuildingType.FAO,
    EBuildingType.ResidentialBuilding,
    EBuildingType.House,
    EBuildingType.Other,
  ],
};

const ALL_BUILDING_TYPES: EBuildingType[] = [
  EBuildingType.BusinessCenter,
  EBuildingType.OfficeBuilding,
  EBuildingType.AdministrativeBuilding,
  EBuildingType.MultifunctionalComplex,
  EBuildingType.ShoppingCenter,
  EBuildingType.Warehouse,
  EBuildingType.FAO,
  EBuildingType.ResidentialBuilding,
  EBuildingType.House,
  EBuildingType.Other,
];

export const getBuildingTypeFields = (officeTypes: EOfficeType[]): EBuildingType[] => {
  if (!officeTypes.length) {
    return ALL_BUILDING_TYPES;
  }

  const unique = officeTypes.reduce((acc, item) => {
    const available = mapOfficeTypeWithBuildingType[item];

    if (available) {
      available.forEach(type => acc.add(type));
    }

    return acc;
  }, new Set<EBuildingType>());

  return Array.from(unique);
};
